module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Rose.7720cde3.png";